import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import WrapGame from './components/WrapGame';
import LandingPage from './components/landing/LandingPage';
import AuthLayout from './components/auth/AuthLayout';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import TermsOfUse from './components/legal/TermsOfUse';
import { AuthProvider } from './context/AuthContext';
import { SubscriptionProvider } from './context/SubscriptionContext';
import StripeProvider from './components/providers/StripeProvider';

function App() {
  return (
    <Router>
      <AuthProvider>
        <SubscriptionProvider>
          <StripeProvider>
            <div className="App relative min-h-screen overflow-hidden bg-black">
              <div className="relative z-10">
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms-of-use" element={<TermsOfUse />} />
                  <Route path="/auth/callback" element={<div className="flex items-center justify-center h-screen">
                    <div className="text-center">
                      <h2 className="text-2xl font-bold mb-4">Processing authentication...</h2>
                      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
                    </div>
                  </div>} />
                  <Route path="/app" element={
                    <AuthLayout>
                      <WrapGame />
                    </AuthLayout>
                  } />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </div>
            </div>
          </StripeProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
